module.exports = __webpack_public_path__ + "img/character02.f70c02f9.png";